module.exports = __webpack_public_path__ + "media/images/oficinas/curuzu_cuatia-a65db11dee8b71cd643cf788fe59f2bb.jpg";